import { useCallback } from 'react'
import { CustomRenderRoundedImage } from '../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import { TwinIconProp } from '../../../baseComponents/TwinIcon'
import { CustomSelectWithSearchBar } from '..'
import { TwinDictionary } from '../../../utils/globals/dictionary'


export interface CustomSelectRoundImageProps extends CustomRenderTaskRoundImageLogicProps {
    img?: string
    name?: string
    className?: string
    items: TwinDictionary
    icon: TwinIconProp
    defaultImage: string
    value?: number
}

export const CustomSelectRoundImage: React.FC<CustomSelectRoundImageProps> = ({ items, value, onChange, icon, defaultImage, ...rest }) => {
    const { onSelectValue } = useCustomSelectRoundImageLogic({ onChange })
    if (value && !rest.img) {
        rest.img = defaultImage
    }
    const extraHeaderParams = { icon, img: rest.img }
    return (
        <div className='relative custom_render_task_round_image' onClick={(e) => { e.preventDefault(); e.stopPropagation()}}>
            <CustomSelectWithSearchBar hideLabel={true} skipBorderStyle={true} className='task' label='' CustomSelectHeader={RoundedImage} items={items} onChange={onSelectValue} sortItems={true}  {...{ extraHeaderParams }} {...rest} />
        </div>
    )
}

interface RoundedImageProps { }

const RoundedImage: React.FC<RoundedImageProps> = ({ extraHeaderParams, ...rest }: any) => {
    const img = extraHeaderParams?.img || ''
    return (
        <CustomRenderRoundedImage className='cursor-pointer h-34 w-34 custom_round_image ' {...rest} icon={extraHeaderParams.icon} img={img || ''} />
    )
}

interface CustomRenderTaskRoundImageLogicProps {
    onChange?:(value: number)=>void
}

const useCustomSelectRoundImageLogic = ({onChange}: CustomRenderTaskRoundImageLogicProps) => {

    const onSelectValue = useCallback(async(value: any) => {
        onChange?.(value)
    }, [onChange])

    return { onSelectValue }
}